import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import TabsContacts from '@/components/TabsContacts/index.vue'
import baseMessage from '@/views/yuntuSales/customerCenter/components/baseMessage.vue'
import { potentialDetail } from '@/api/yuntuSales/customerCenter'
import { useRoute } from 'vue-router'

const __default__ = {
  name: 'LbuClientsView'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  type: {
    type: String
  }
},
  setup(__props) {


const route = useRoute()
const data = ref({})
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    potentialDetail(route.query.cosId).then((res) => {
      data.value = res.data
    })
  }
}
onMounted(() => {
  fetch()
})
const permissionBasic = {
  transfer: 'lbu_clients_transfer_btn',
  visitor_add: 'lbu_clients_visitor_add_btn',
  edit: 'lbu_clients_edit_btn'
}
// const permissionFollow = {
//   add: 'lbu_clients_follow_add_btn',
//   edit: 'lbu_clients_follow_edit_btn',
//   del: 'lbu_clients_follow_del_btn'
// }
// const permissionBuss = {
//   add: 'lbu_clients_buss_add_btn',
//   edit: 'lbu_clients_buss_edit_btn',
//   del: 'lbu_clients_buss_del_btn'
// }
const permissionConcat = {
  add: 'lbu_clients_concat_add_btn',
  edit: 'lbu_clients_concat_edit_btn',
  del: 'lbu_clients_concat_del_btn'
}

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_CosViewContent, {
            header: "",
            title: data.value?.customerInfo?.customerName,
            sellerName: data.value?.customerInfo?.sellerName,
            customLabel: "联系人姓名",
            customValue: data.value?.contact?.name
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, {
                activeKey: _ctx.activeKey,
                "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "1",
                    tab: "基本信息"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(baseMessage, {
                        disabled: true,
                        perfect: true,
                        data: data.value,
                        type: __props.type,
                        content: ['customerInfo', 'business'],
                        permissionPage: permissionBasic,
                        view: "",
                        hideOk: true
                      }, null, 8, ["data", "type"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "2",
                    tab: "联系人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsContacts, {
                        appId: "cos_lbu",
                        contactRefId: _unref(route).query.cosId,
                        permissionPage: permissionConcat,
                        hideOk: true
                      }, null, 8, ["contactRefId"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["activeKey"])
            ]),
            _: 1
          }, 8, ["title", "sellerName", "customValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})